import { z } from "zod";

/**
 * Office avatar actions — shared by protocol, world engine, and dock UI.
 * Procedural canvas poses (no sprite sheets); durations drive client animation timers.
 */
export const OFFICE_ACTIONS = [
  {
    id: "wave",
    label: "Wave",
    emoji: "👋",
    description: "Say hi to nearby teammates",
    duration: 1.6,
    shortcut: "1",
    social: true,
  },
  {
    id: "jump",
    label: "Jump",
    emoji: "⬆️",
    description: "A quick hop",
    duration: 0.55,
    shortcut: "2",
    social: false,
  },
  {
    id: "dance",
    label: "Dance",
    emoji: "💃",
    description: "Boogie in place",
    duration: 2.4,
    shortcut: "3",
    social: false,
  },
  {
    id: "handshake",
    label: "Handshake",
    emoji: "🤝",
    description: "Offer a handshake to someone nearby",
    duration: 1.5,
    shortcut: "4",
    social: true,
  },
  {
    id: "clap",
    label: "Clap",
    emoji: "👏",
    description: "Celebrate a win",
    duration: 1.2,
    shortcut: "5",
    social: false,
  },
  {
    id: "cheer",
    label: "Cheer",
    emoji: "🎉",
    description: "Both arms up",
    duration: 1.5,
    shortcut: "6",
    social: false,
  },
] as const;

export type OfficeActionId = (typeof OFFICE_ACTIONS)[number]["id"];

export const OFFICE_ACTION_IDS = OFFICE_ACTIONS.map((a) => a.id) as [
  OfficeActionId,
  ...OfficeActionId[],
];

export const officeActionIdSchema = z.enum(OFFICE_ACTION_IDS);

export function getOfficeAction(id: string): (typeof OFFICE_ACTIONS)[number] | undefined {
  return OFFICE_ACTIONS.find((a) => a.id === id);
}

export const ACTION_SHORTCUT_MAP: Record<string, OfficeActionId> = Object.fromEntries(
  OFFICE_ACTIONS.map((a) => [a.shortcut, a.id]),
) as Record<string, OfficeActionId>;
